import { render, staticRenderFns } from "./TheIndexSlider.vue?vue&type=template&id=fa1cb914&scoped=true&"
import script from "./TheIndexSlider.vue?vue&type=script&lang=coffee&"
export * from "./TheIndexSlider.vue?vue&type=script&lang=coffee&"
import style0 from "./TheIndexSlider.vue?vue&type=style&index=0&id=fa1cb914&lang=sass&scoped=true&"
import style1 from "./TheIndexSlider.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1cb914",
  null
  
)

export default component.exports